import { DynamicFileSelectComponent } from './../dynamic-file-select/dynamic-file-select.component';
import { ComponentFactoryResolver, ComponentRef, Directive, Input, OnInit, ViewContainerRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { DynamicButtonComponent } from "../dynamic-button/dynamic-button.component";
import { DynamicCheckboxComponent } from "../dynamic-checkbox/dynamic-checkbox.component";
import { DynamicDateComponent } from "../dynamic-date/dynamic-date.component";
import { DynamicInputComponent } from "../dynamic-input/dynamic-input.component";
import { DynamicRadioButtonComponent } from "../dynamic-radio-button/dynamic-radio-button.component";
import { DynamicSelectComponent } from "../dynamic-select/dynamic-select.component";
import { FieldConfig } from "../models/dynamic-form-field";
import { DynamicTextAreaComponent } from '../dynamic-text-area/dynamic-text-area.component';


const componentMapper = {
  input: DynamicInputComponent,
  button: DynamicButtonComponent,
  select: DynamicSelectComponent,
  date: DynamicDateComponent,
  radiobutton: DynamicRadioButtonComponent,
  checkbox: DynamicCheckboxComponent,
  files: DynamicFileSelectComponent,
  textarea: DynamicTextAreaComponent
};
@Directive({
  selector: "[optsol-ngx-dynamicField]"
})
export class DynamicFieldDirective implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: FormGroup;
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {}
  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.field.type]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;



  }
}
